"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _pageError = _interopRequireDefault(require("@maas-components/page-error"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function PageError() {
  return /*#__PURE__*/_react["default"].createElement(_pageError["default"], {
    errorType: "AccountsError",
    title: "H\xE1 problemas com a sua conta.",
    message: "N\xE3o estamos conseguindo acessar os dados da sua conta e empresa.",
    buttonText: "Tentar novamente",
    buttonUrl: "/"
  });
}

var _default = PageError;
exports["default"] = _default;